import { PropsWithChildren, ReactNode } from 'react';
import { Tooltip } from './Tooltip';

interface TableTooltipProps extends PropsWithChildren {
  tooltip: ReactNode;
}

export const TableTooltip = ({ children, tooltip }: TableTooltipProps) => (
  <Tooltip
    content={tooltip}
    TooltipTriggerProps={{ asChild: true }}
    TooltipContentProps={{
      withArrow: true,
      variant: 'secondary',
      className: 'max-w-75',
      TooltipArrowProps: { className: 'fill-secondary' },
    }}
  >
    {children}
  </Tooltip>
);
